module.exports = __webpack_public_path__ + "img/google.c0e9477d.png";